export const errorMessagePayment =
  'Não foi possível efetuar o pagamento desta compra. Revise os dados e tente novamente ou volte para selecionar outro método de pagamento.';
export const errorMessageGeneric = (code: number) =>
  `${code} - Estamos enfrentando alguns problemas. Atualize a página e tente novamente.`;
export const errorMessagePaymentGeneric = (code: number) =>
  `${code} - ${errorMessagePayment}`;
